module.exports = __webpack_public_path__ + "static/img/shehuizhaoping.64e6036.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jobs/shehuizhaoping.png
// module id = 781R
// module chunks = 1